import * as React from "react"
import * as DialogPrimitive from "@radix-ui/react-dialog"
import { cn } from "@/lib/utils"

const FullScreenDialog = DialogPrimitive.Root
const FullScreenDialogTrigger = DialogPrimitive.Trigger
const FullScreenDialogPortal = DialogPrimitive.Portal
const FullScreenDialogClose = DialogPrimitive.Close

const FullScreenDialogOverlay = React.forwardRef<
  React.ElementRef<typeof DialogPrimitive.Overlay>,
  React.ComponentPropsWithoutRef<typeof DialogPrimitive.Overlay>
>(({ className, ...props }, ref) => (
  <DialogPrimitive.Overlay
    ref={ref}
    className={cn(
      "fixed inset-0 z-[100] bg-background data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      className
    )}
    {...props}
  />
))
FullScreenDialogOverlay.displayName = DialogPrimitive.Overlay.displayName

const FullScreenDialogContent = React.forwardRef<
  React.ElementRef<typeof DialogPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof DialogPrimitive.Content>
>(({ className, children, ...props }, ref) => (
  <FullScreenDialogPortal>
    <FullScreenDialogOverlay />
    <DialogPrimitive.Content
      ref={ref}
      className={cn(
        "fixed inset-0 z-[100] bg-background overflow-y-auto data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 duration-200",
        className
      )}
      {...props}
    >
      {children}
    </DialogPrimitive.Content>
  </FullScreenDialogPortal>
))
FullScreenDialogContent.displayName = DialogPrimitive.Content.displayName

export {
  FullScreenDialog,
  FullScreenDialogTrigger,
  FullScreenDialogPortal,
  FullScreenDialogClose,
  FullScreenDialogOverlay,
  FullScreenDialogContent,
}

